import type { LocaleCode } from "@/lib/labels/types";

/**
 * Cookie name for the user's chosen locale preference.
 * Read in middleware (server) to redirect un-prefixed URLs, and in the
 * inline head script on the homepage to decide whether to show the overlay.
 */
export const PREFERRED_LOCALE_COOKIE = "fu-preferred-locale";

const ONE_YEAR_SECONDS = 31_536_000;

/**
 * Persist the user's chosen locale to the cookie. Must run in the browser.
 * Called on explicit user actions only — language switcher click or
 * first-visit overlay selection. Never set on page load.
 */
export function persistLocaleChoice(locale: LocaleCode): void {
    const secure = typeof location !== "undefined" && location.protocol === "https:" ? "; Secure" : "";
    document.cookie =
        `${PREFERRED_LOCALE_COOKIE}=${locale}; Path=/; Max-Age=${ONE_YEAR_SECONDS}; SameSite=Lax${secure}`;
}
